import { cn } from '@/lib/cn';
import { Eyebrow } from '@/components/ui';
import { useTaskStore } from '@/stores/taskStore';
import type { EnergyLevel, Task } from '@/types';

const OPTIONS: { value: EnergyLevel; label: string }[] = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
];

export function EnergyField({ task }: { task: Task }) {
  const updateTask = useTaskStore((s) => s.updateTask);
  return (
    <div>
      <Eyebrow className="mb-1" aria-hidden>
        Energy
      </Eyebrow>
      <div className="flex flex-wrap gap-1" role="group" aria-label="Energy">
        {OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            aria-pressed={task.energyRequired === opt.value}
            onClick={() => updateTask(task.id, { energyRequired: opt.value })}
            className={cn(
              'pressable rounded-full border px-2.5 py-1 text-caption transition-colors pointer-coarse:min-h-[44px] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-canvas',
              task.energyRequired === opt.value
                ? 'border-t1 bg-t1 text-canvas'
                : 'border-line-2 bg-bg text-t2 can-hover:hover:bg-card',
            )}
          >
            {opt.label}
          </button>
        ))}
      </div>
    </div>
  );
}
